export default {
  name: 'Home',

  data() {
    return {}
  },

  mounted() {
    this.init();
  },

  methods:{
    async init() {
      Paddle.Initialize({
          token: 'test_582ac19bbd2b2354f26dfa7578b', 
          checkout: {
            settings: {
              displayMode: "inline",
              theme: "light",
              locale: "en",
              frameTarget: "checkout-container",
              frameInitialHeight: "450",
              frameStyle:
                "width: 100%; min-width: 312px; background-color: transparent; border: none;",
            }
          },
          eventCallback: (event) => {
            console.log(event);
          }
      });
    }
  }
}
